export default __webpack_public_path__ + "static/media/6ixer10.3a38f507.jpg";